import { useState } from 'react'

import { formatPrice } from '../../../utils/common'
import CampaignSidebarRate from '../CampaignSidebarRate'
import styles from './Sidebar.module.scss'

const Card = ({ title, children }) => (
  <div className={styles.card}>
    {title && <h3>{title}</h3>}
    {children}
  </div>
)

const Fact = ({ title, value }) => (
  <div className={styles.fact}>
    <div className={styles.factTitle}>{title}</div>
    <div className={styles.factValue}>{value}</div>
  </div>
)

const Funnel = ({ children }) => <div className={styles.funnel}>{children}</div>

const FunnelItem = ({ name, value }) => (
  <div className={styles.funnelItem}>
    <b>{value}</b>
    <p>{name}</p>
  </div>
)

const Sidebar = ({ data }) => {
  const summaries =
    data &&
    data.campaignsSummary.map(campaign => (
      <CampaignSidebarRate key={campaign.uiId} {...campaign} />
    ))

  const [showingAllSummaries, setShowingAllSummaries] = useState(false)

  return (
    <div className={[styles.sidebar, 'analyticsSidebar'].join(' ')}>
      {data ? (
        <>
          <Card title="Campaigns">
            {showingAllSummaries ? summaries : summaries.slice(0, 3)}
            {summaries.length > 3 && (
              <button
                className={styles.cardLink}
                onClick={() => setShowingAllSummaries(!showingAllSummaries)}
              >
                See {showingAllSummaries ? 'less' : 'more'} campaigns
              </button>
            )}
          </Card>
          <Card>
            <Fact
              title="Average conversion"
              value={formatPercentage(data.averageConversion)}
            />
            <Fact title="Average click rate" value={formatPercentage(data.clickRate)} />
            <Fact
              title="Conversion revenue"
              value={formatPrice(data.totalConvertedRevenue)}
            />
          </Card>
          <Funnel>
            <FunnelItem value={data.totalInvitesSent} name="texts sent" />
            <FunnelItem value={data.totalClicks} name="clicks" />
            <FunnelItem value={data.totalBookings} name="bookings" />
          </Funnel>
        </>
      ) : (
        <>
          <Card />
          <Card />
          <Funnel />
        </>
      )}
    </div>
  )
}

const formatPercentage = num => `${num.toFixed(2)}%`

// <div className="aiv-sidebar__title">Average conversion</div>
// <div className="aiv-sidebar__value">{averageConversion && `${(averageConversion * 100).toFixed(2)}%`}</div>
// </div>
// <div className="aiv-sidebar__card">
// {/* <img src={ReturnedCustomers}></img> */}
// <div className="aiv-sidebar__title">Bookings</div>
// <div className="aiv-sidebar__value">{totalBookings}</div>
// </div>
// <div className="aiv-sidebar__card">
// <div className="aiv-sidebar__title">Conversion revenue</div>

export default Sidebar
